module.exports = __webpack_public_path__ + "img/EricJ.c3966c7.png";